import type { Locale } from '@enmon/commons';
import { DEFAULT_LOCALE } from '@enmon-monorepo/i18n';
import { atom } from 'recoil';

export const localeAtom = atom<Locale>({
  key: 'app/LanguageProvider/localeState',
  default: DEFAULT_LOCALE,
});
